var _defs, _rect, _defs2, _g, _rect2, _g2, _defs3, _g3, _defs4, _defs5, _rect3, _g4, _defs6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavvyGeniesMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2400,
    height: 1800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 0,
    height: 0,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "watermark",
    patternUnits: "userSpaceOnUse",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 1800,
    viewBox: "0 0 340.000000 250.000000",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#5f71bd",
    className: "iconblsvg-g iconsvg",
    transform: "translate(40.90562438964844,109.78266906738281)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0.35492161530969035)",
    fill: "url(#85bb405f-01ee-43f0-870c-1b7838ded864)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.92-13.04C7.61-13.79 6.05-14.44 6.05-16 6.05-17.38 7.3-18.37 9.55-18.37 11.6-18.37 14.32-17.72 16.25-16.91L18.06-20.46C15.91-21.4 12.98-22.24 9.64-22.24 4.62-22.24 1.53-19.5 1.53-15.63 1.53-11.29 5.18-10.01 9.7-8.98 12.92-8.24 14.38-7.58 14.38-6.08 14.38-4.46 12.95-3.59 10.54-3.59 7.8-3.59 5.77-3.87 2.87-5.27L1.25-1.81C4.74-0.06 6.64 0.28 10.39 0.28 15.5 0.28 18.9-2.21 18.9-6.46 18.9-10.48 15.66-11.98 10.92-13.04ZM34.78-16.94L34.78-15.88C33.35-16.72 31.6-17.28 29.82-17.28 24.52-17.28 21.4-13.04 21.4-8.52 21.4-4.02 24.52 0.25 29.82 0.25 31.69 0.25 33.38-0.31 34.78-1.25L34.78 0 39.12 0 39.12-16.94ZM34.78-5.08C33.72-4.18 32.26-3.65 30.6-3.65 27.55-3.65 25.58-5.96 25.58-8.52 25.58-11.04 27.51-13.35 30.6-13.35 32.23-13.35 33.72-12.79 34.78-11.89ZM54.44-16.94L49.85-7.33 45.23-16.94 40.68-16.94 48.82 0 50.88 0 58.99-16.94ZM73.28-16.94L68.69-7.33 64.08-16.94 59.52-16.94 67.66 0 69.72 0 77.83-16.94ZM92.03-16.94L87.66-5.43 87.35-5.43 82.89-16.94 78.33-16.94 84.95 0 85.32 0C84.35 1.97 82.26 2.56 79.92 2.56L79.46 2.56 78.93 5.83C79.39 5.86 79.89 5.86 80.45 5.86 84.01 5.86 88 4.74 89.5 0.9L96.49-16.94Z",
    transform: "translate(-1.25, 23.860000610351562)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.23999786376953, 0)",
    mask: "url(#6c3f64d9-c04d-4c0c-bcb9-c16ecf6da61c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "imagesvg"
  }, /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5f71bd",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 52.18874978162912,
    height: 30.434662045060662,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    filter: "url(#colors7597965896)",
    x: 0,
    y: 0,
    width: 52.18874978162912,
    height: 30.434662045060662,
    filtersec: "colorsf4702840131",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "8.999858856201172 112.60749816894531 489.865966796875 285.67254638671875",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.12,380.07c-1.69-5.2-6.54-8.72-12.02-8.72h-85.35c-5.47,0-10.32,3.52-12.02,8.72l-4.58,14.07   c-0.67,2.04,0.86,4.14,3,4.14h112.54c2.15,0,3.67-2.1,3-4.14L296.12,380.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,350.85c-6.8,0-13.53-0.59-20.14-1.73l-9.08,14.23h57.38l-9.52-13.85C254.03,350.39,247.81,350.85,241.51,350.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.44,207.02c2.85-6.27,3.7-13.32,2.43-20.11c-5.1,0.86-10.22,1.58-15.36,2.12   C266.66,196.32,271.25,202.69,277.44,207.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.34,201.49l-24.27-17.51l-4.36,1.08c-0.04,0.01-0.09,0.02-0.14,0.03c-0.61,0.13-1.23,0.24-1.85,0.36   c1.41,7.52,0.7,15.3-2,22.42C296.63,206.32,307.51,204.19,318.34,201.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,189.73c-0.95,0.07-1.91,0.13-2.86,0.19c-0.43,7.57-2.95,14.89-7.19,21.12c7.34-0.13,14.66-0.51,21.98-1.14   c-5.57-5.22-9.69-11.94-11.72-19.4L256.39,189.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.99,205.61c5.41-4.27,9.41-10.16,11.39-16.78c-5.02-0.55-10.04-1.23-15.07-2.07   C195.69,193.26,196.97,199.84,199.99,205.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,189.78c-0.89-0.06-1.79-0.12-2.68-0.19c-1.95,7.56-6.01,14.42-11.62,19.77c7.13,0.74,14.27,1.25,21.4,1.51   C225.04,204.65,222.55,197.34,222.15,189.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,209.04c4.4-5.3,7.08-11.89,7.64-18.77c-2.18,0.06-4.37,0.09-6.55,0.09c-2.91,0-5.82-0.07-8.73-0.17   C230.74,197.1,233.43,203.72,237.84,209.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,219.03c12.11-2.71,23.22-5.99,34.12-9.82c-0.65-0.17-1.29-0.35-1.94-0.55l-5.05-1.55l-7.32,1.67   c-26.91,6.87-54.11,10.31-81.39,10.31c-25.22,0-50.5-2.94-75.69-8.81l-3.13-0.73l-2.77-0.71c-1.83,1.75-3.79,3.35-5.86,4.79   l16.03,4.13C212.75,228.21,258.76,228.65,302.38,219.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,207.32c-3.13-6.85-4.37-14.48-3.52-21.99l-6.11-1.16c-1.41,1.33-2.79,2.69-4.1,4.12l-12.72,13.85l1.45,0.34   C175.26,204.43,183.6,206.03,191.94,207.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.12,210.97l-5.88-10.81c-2.34-4.3-6.67-7.16-11.55-7.61l-22.22-2.05c-31.66-2.92-63.53,2.6-92.36,16.01l0,0   c-2.11,0.98-4.29,1.78-6.51,2.41c-16.63,6.85-34.83,13.31-55.5,17.92c-21.44,4.73-43.44,7.09-65.44,7.09   c-23.98,0-47.96-2.8-71.22-8.41l-24.6-6.34c-3.14,1.2-6.42,2.08-9.78,2.61l-3.35,0.53c-11.1,0-21.65-4.89-28.82-13.36l-3.92-4.63   c-17.47-20.62-47.86-24.32-69.77-8.5h0c-21,15.17-24.37,45.13-7.27,64.59h0c14.28,16.25,38.27,19.67,56.53,8.07l8.96-5.69   c4.78-3.04,5.98-9.5,2.61-14.05h0c-3.04-4.1-8.72-5.17-13.04-2.46l-9.1,5.72c-10.13,6.37-23.38,4.42-31.26-4.58h0   c-9.44-10.79-7.56-27.36,4.07-35.75c13.56-9.79,32.43-7.11,42.72,6.08l16.7,21.41c20.99,26.9,44.21,51.99,69.41,74.99l0,0   c20.22,18.46,46.61,28.69,73.99,28.69h0c31.57,0,61.85-12.54,84.18-34.86l56.94-56.91c19.81-19.8,46.65-30.95,74.65-31.02   l35.48-0.09C497.39,219.97,500.32,215.03,498.12,210.97z M352.88,248.1l-11.2,4.86c-32.21,13.98-66.85,20.97-101.49,20.97   c-33.88,0-67.75-6.69-99.37-20.07c-2.03-0.86-2.99-3.21-2.12-5.24c0.86-2.04,3.21-2.99,5.24-2.12   c61.94,26.22,132.86,25.91,194.56-0.87l11.2-4.86c2.03-0.88,4.38,0.05,5.26,2.08C355.84,244.87,354.91,247.22,352.88,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,177.76c-13.84-10.14-30.56-15.61-47.72-15.61h0c-17.17,0-33.74,5.48-47.43,15.4l0.63,0.12   C222.92,183.89,254.7,183.9,285.44,177.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,155.31c3.46-0.56,6.97-0.93,10.51-1.08v-10.39c0-2.21,1.79-4,4-4s4,1.79,4,4v10.41c3.54,0.16,7.04,0.53,10.5,1.1   l1.1-4.41c3.2-12.84-0.49-26.43-9.76-35.88c-3.21-3.27-8.47-3.27-11.68,0c-9.27,9.45-12.96,23.03-9.76,35.88L223.33,155.31z"
  }))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7597965896"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40234375  0 0 0 0 0.3046875  0 0 0 0 0.65234375  0 0 0 1 0",
    className: "icon-feColorMatrix "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf4702840131"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb9819916791"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    "v-gra": "id",
    width: 64.18875122070312,
    height: 42.434661865234375,
    transform: "translate(-6, -6)",
    style: {
      pointerEvents: "none"
    },
    fill: "url(#GkmbVkib2zGRJdRKkPhHm)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#ea894b3e-b465-4ee1-9666-6969d2bff2e3)",
    transform: "translate(153.42874908447266, 0.35492161530969035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6-11.01L12.6-7.27 18.19-7.27 18.19-5.21C16.78-4.27 15.04-3.71 13.07-3.71 9.14-3.71 5.96-6.89 5.96-10.98 5.96-14.85 9.14-18.03 13.07-18.03 15.47-18.03 17.59-17.25 19.06-15.94L21.87-19.06C19.75-20.99 16.75-22.21 13.07-22.21 6.64-22.21 1.4-17.19 1.4-10.98 1.4-4.77 6.64 0.25 13.07 0.25 16.85 0.25 20.21-1 22.65-2.96L22.65-11.01ZM42.33-7.24C42.33-7.52 42.36-7.86 42.36-8.2 42.36-13.48 39.34-17.25 34.13-17.25 29.01-17.25 25.46-13.35 25.46-8.49 25.46-3.65 29.01 0.25 34.13 0.25 37.44 0.25 40.21-1.12 41.77-3.24L38.99-5.55C38.06-4.27 36.41-3.46 34.63-3.46 32.04-3.46 30.26-5.02 29.79-7.24ZM34.13-13.79C37.03-13.79 38.06-11.95 38.21-10.01L29.82-10.01C30.23-12.1 31.85-13.79 34.13-13.79ZM54.31-17.25C52.6-17.25 51.04-16.75 49.79-15.88L49.79-16.94 45.45-16.94 45.45 0 49.79 0 49.79-12.01C50.76-12.85 52-13.35 53.53-13.35 55.93-13.35 57.21-12.07 57.21-9.45L57.21 0 61.55 0 61.55-9.45C61.55-14.94 59.27-17.25 54.31-17.25ZM65.39 0L69.72 0 69.72-16.94 65.39-16.94ZM67.54-18.78C68.91-18.78 70-19.9 70-21.31 70-22.71 68.91-23.86 67.54-23.86 66.17-23.86 65.04-22.71 65.04-21.31 65.04-19.9 66.17-18.78 67.54-18.78ZM89.84-7.24C89.84-7.52 89.88-7.86 89.88-8.2 89.88-13.48 86.85-17.25 81.64-17.25 76.52-17.25 72.97-13.35 72.97-8.49 72.97-3.65 76.52 0.25 81.64 0.25 84.95 0.25 87.72-1.12 89.28-3.24L86.51-5.55C85.57-4.27 83.92-3.46 82.14-3.46 79.55-3.46 77.77-5.02 77.3-7.24ZM81.64-13.79C84.54-13.79 85.57-11.95 85.73-10.01L77.33-10.01C77.74-12.1 79.36-13.79 81.64-13.79ZM92.03-1.37C94.52-0.16 96.43 0.25 99.36 0.25 103.69 0.25 106.16-1.87 106.16-5.08 106.16-8.17 103.88-9.55 99.95-10.36 97.24-10.92 96.21-11.36 96.21-12.29 96.21-13.2 97.05-13.79 98.7-13.79 100.39-13.79 102.32-13.32 103.98-12.7L105.41-15.88C103.57-16.63 101.45-17.25 98.8-17.25 94.87-17.25 92.34-15.13 92.34-12.07 92.34-8.8 94.99-7.61 98.64-6.8 101.26-6.24 102.23-5.8 102.23-4.84 102.23-3.96 101.45-3.21 99.45-3.21 97.33-3.21 95.74-3.68 93.65-4.59Z",
    transform: "translate(-1.399999976158142, 23.860000610351562)"
  })))))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0,
    id: "85bb405f-01ee-43f0-870c-1b7838ded864"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5f71bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b23ea"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "42443b3f1de60f6b6fd3b6a9844b4764",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0,
    id: "ea894b3e-b465-4ee1-9666-6969d2bff2e3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5f71bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b23ea"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "42443b3f1de60f6b6fd3b6a9844b4764",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "id"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "4a2ce20e-2039-492d-8265-5a4639cd7f83",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0,
    id: "GkmbVkib2zGRJdRKkPhHm"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#12c2e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#c471ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f64f59"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "42443b3f1de60f6b6fd3b6a9844b4764",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    "v-gra": "im",
    id: "6c3f64d9-c04d-4c0c-bcb9-c16ecf6da61c"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#4a2ce20e-2039-492d-8265-5a4639cd7f83)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "imagesvg"
  }, /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#5f71bd",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 52.18874978162912,
    height: 30.434662045060662,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 52.18874978162912,
    height: 30.434662045060662,
    filtersec: "colorsf4702840131",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "8.999858856201172 112.60749816894531 489.865966796875 285.67254638671875",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.12,380.07c-1.69-5.2-6.54-8.72-12.02-8.72h-85.35c-5.47,0-10.32,3.52-12.02,8.72l-4.58,14.07   c-0.67,2.04,0.86,4.14,3,4.14h112.54c2.15,0,3.67-2.1,3-4.14L296.12,380.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,350.85c-6.8,0-13.53-0.59-20.14-1.73l-9.08,14.23h57.38l-9.52-13.85C254.03,350.39,247.81,350.85,241.51,350.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.44,207.02c2.85-6.27,3.7-13.32,2.43-20.11c-5.1,0.86-10.22,1.58-15.36,2.12   C266.66,196.32,271.25,202.69,277.44,207.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.34,201.49l-24.27-17.51l-4.36,1.08c-0.04,0.01-0.09,0.02-0.14,0.03c-0.61,0.13-1.23,0.24-1.85,0.36   c1.41,7.52,0.7,15.3-2,22.42C296.63,206.32,307.51,204.19,318.34,201.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.39,189.73c-0.95,0.07-1.91,0.13-2.86,0.19c-0.43,7.57-2.95,14.89-7.19,21.12c7.34-0.13,14.66-0.51,21.98-1.14   c-5.57-5.22-9.69-11.94-11.72-19.4L256.39,189.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.99,205.61c5.41-4.27,9.41-10.16,11.39-16.78c-5.02-0.55-10.04-1.23-15.07-2.07   C195.69,193.26,196.97,199.84,199.99,205.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.15,189.78c-0.89-0.06-1.79-0.12-2.68-0.19c-1.95,7.56-6.01,14.42-11.62,19.77c7.13,0.74,14.27,1.25,21.4,1.51   C225.04,204.65,222.55,197.34,222.15,189.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,209.04c4.4-5.3,7.08-11.89,7.64-18.77c-2.18,0.06-4.37,0.09-6.55,0.09c-2.91,0-5.82-0.07-8.73-0.17   C230.74,197.1,233.43,203.72,237.84,209.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,219.03c12.11-2.71,23.22-5.99,34.12-9.82c-0.65-0.17-1.29-0.35-1.94-0.55l-5.05-1.55l-7.32,1.67   c-26.91,6.87-54.11,10.31-81.39,10.31c-25.22,0-50.5-2.94-75.69-8.81l-3.13-0.73l-2.77-0.71c-1.83,1.75-3.79,3.35-5.86,4.79   l16.03,4.13C212.75,228.21,258.76,228.65,302.38,219.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,207.32c-3.13-6.85-4.37-14.48-3.52-21.99l-6.11-1.16c-1.41,1.33-2.79,2.69-4.1,4.12l-12.72,13.85l1.45,0.34   C175.26,204.43,183.6,206.03,191.94,207.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.12,210.97l-5.88-10.81c-2.34-4.3-6.67-7.16-11.55-7.61l-22.22-2.05c-31.66-2.92-63.53,2.6-92.36,16.01l0,0   c-2.11,0.98-4.29,1.78-6.51,2.41c-16.63,6.85-34.83,13.31-55.5,17.92c-21.44,4.73-43.44,7.09-65.44,7.09   c-23.98,0-47.96-2.8-71.22-8.41l-24.6-6.34c-3.14,1.2-6.42,2.08-9.78,2.61l-3.35,0.53c-11.1,0-21.65-4.89-28.82-13.36l-3.92-4.63   c-17.47-20.62-47.86-24.32-69.77-8.5h0c-21,15.17-24.37,45.13-7.27,64.59h0c14.28,16.25,38.27,19.67,56.53,8.07l8.96-5.69   c4.78-3.04,5.98-9.5,2.61-14.05h0c-3.04-4.1-8.72-5.17-13.04-2.46l-9.1,5.72c-10.13,6.37-23.38,4.42-31.26-4.58h0   c-9.44-10.79-7.56-27.36,4.07-35.75c13.56-9.79,32.43-7.11,42.72,6.08l16.7,21.41c20.99,26.9,44.21,51.99,69.41,74.99l0,0   c20.22,18.46,46.61,28.69,73.99,28.69h0c31.57,0,61.85-12.54,84.18-34.86l56.94-56.91c19.81-19.8,46.65-30.95,74.65-31.02   l35.48-0.09C497.39,219.97,500.32,215.03,498.12,210.97z M352.88,248.1l-11.2,4.86c-32.21,13.98-66.85,20.97-101.49,20.97   c-33.88,0-67.75-6.69-99.37-20.07c-2.03-0.86-2.99-3.21-2.12-5.24c0.86-2.04,3.21-2.99,5.24-2.12   c61.94,26.22,132.86,25.91,194.56-0.87l11.2-4.86c2.03-0.88,4.38,0.05,5.26,2.08C355.84,244.87,354.91,247.22,352.88,248.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.44,177.76c-13.84-10.14-30.56-15.61-47.72-15.61h0c-17.17,0-33.74,5.48-47.43,15.4l0.63,0.12   C222.92,183.89,254.7,183.9,285.44,177.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,155.31c3.46-0.56,6.97-0.93,10.51-1.08v-10.39c0-2.21,1.79-4,4-4s4,1.79,4,4v10.41c3.54,0.16,7.04,0.53,10.5,1.1   l1.1-4.41c3.2-12.84-0.49-26.43-9.76-35.88c-3.21-3.27-8.47-3.27-11.68,0c-9.27,9.45-12.96,23.03-9.76,35.88L223.33,155.31z"
  }))))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7597965896"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40234375  0 0 0 0 0.3046875  0 0 0 0 0.65234375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf4702840131"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb9819916791"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavvyGeniesMainLogo);
export default __webpack_public_path__ + "static/media/SavvyGeniesMainLogo.9772a6254ad98926a3285e151a68c653.svg";
export { ForwardRef as ReactComponent };